export { default } from './filtered-articles';
export { default as BlogArticlesFilteredConfig } from './blog-articles-filtered.config';
